import { IDigitalSignApprover } from "domain/contracts/digital-sign-approver.contracts";
import { DigitalSignApprover } from "domain/entities/digital-sign-approver";
import { DigitalSignApproverInputFilter } from "domain/models/digital-sign-approver-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";

class DigitalSignApproverRepository implements IDigitalSignApprover {
  // async delete(id: string): Promise<Message<boolean>> {
  //   const response = await httpClient.delete(`/digitalSignApprover/${id}`);
  //   return response.data;
  // }

  async create(
    input: DigitalSignApprover
  ): Promise<Message<DigitalSignApprover>> {
    const response = await httpClient.post(`/digitalSignApprover`, {
      data: input,
    });
    return response.data;
  }

  // async update(input: DigitalSignApprover): Promise<Message<boolean>> {
  //   const response = await httpClient.put(`/digitalSignApprover/${input.id}`, {
  //     data: input,
  //   });
  //   return response.data;
  // }

  async getAll(
    filter: DigitalSignApproverInputFilter
  ): Promise<Message<DigitalSignApprover[]>> {
    const response = await httpClient.get(`/digitalSignApprover`, {
      params: filter,
    });
    return response.data;
  }

  async getById(id: string): Promise<Message<DigitalSignApprover>> {
    const response = await httpClient.get(`/digitalSignApprover/${id}`);
    return response.data;
  }
}

export default new DigitalSignApproverRepository();
